import type { BundleId } from './pricing';
import { sceneImages } from './images';

export type SpaceOption = {
  id: string;
  label: string;
  labelEs: string;
  note: string;
  image: string;
  recommendedQty: number;
  bundleId: BundleId | null;
};

// Illustrative starting recommendations — not coverage calculations.
export const spaceOptions: SpaceOption[] = [
  {
    id: 'spa',
    label: 'Spa / Hot Tub',
    labelEs: 'Spa / Jacuzzi',
    note: 'Compact water, close viewing distance.',
    image: sceneImages.spa,
    recommendedQty: 4,
    bundleId: 'sys4',
  },
  {
    id: 'small',
    label: 'Small Pool',
    labelEs: 'Piscina pequeña',
    note: 'Plunge pools and compact backyard pools.',
    image: sceneImages.poolSteps,
    recommendedQty: 8,
    bundleId: 'sys8',
  },
  {
    id: 'medium',
    label: 'Medium Pool',
    labelEs: 'Piscina mediana',
    note: 'Typical family backyard pools.',
    image: sceneImages.mediumPool,
    recommendedQty: 12,
    bundleId: 'sys12',
  },
  {
    id: 'large',
    label: 'Large Pool',
    labelEs: 'Piscina grande',
    note: 'Long, deep or architectural pools.',
    image: sceneImages.heroPool,
    recommendedQty: 24,
    bundleId: 'sys24',
  },
  {
    id: 'custom',
    label: 'Custom Space',
    labelEs: 'Espacio personalizado',
    note: 'Steps, fountains, ponds, accents.',
    image: sceneImages.waterTexture,
    recommendedQty: 2,
    bundleId: null,
  },
];
